/**
 * Safe internal redirect validation.
 *
 * Accepts only same-origin, absolute application paths ("/dashboard",
 * "/jobs?x=1"). Rejects protocol-relative ("//evil.example.com"),
 * backslash-obfuscated ("/\\evil.example.com") and absolute external URLs,
 * which browsers would otherwise resolve to a third-party origin.
 *
 * Behaviour for every legitimate in-app path is unchanged.
 */
export const isSafeInternalPath = (path: string | null | undefined): path is string => {
  if (!path) return false;
  if (!path.startsWith("/")) return false;
  // Protocol-relative or backslash-escaped external targets
  if (path.startsWith("//") || path.startsWith("/\\")) return false;
  if (/^\/[\\/]/.test(path)) return false;
  return true;
};
